export default "__VITE_ASSET__bBOFSd43__"